"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/** passes through events as they happen. You will not get events from before you start listening */
var TypedEventEmitter = /** @class */ (function () {
    function TypedEventEmitter() {
        this.listeners = {};
        this.listenersOnce = {};
    }
    TypedEventEmitter.prototype.on = function (eventType, listener) {
        var _this = this;
        if (!this.listeners[eventType]) {
            this.listeners[eventType] = [];
        }
        this.listeners[eventType].push(listener);
        return function () { return _this.off(eventType, listener); };
    };
    TypedEventEmitter.prototype.once = function (eventType, listener) {
        if (!this.listenersOnce[eventType]) {
            this.listenersOnce[eventType] = [];
        }
        this.listenersOnce[eventType].push(listener);
    };
    TypedEventEmitter.prototype.off = function (eventType, listener) {
        var callbackIndex = (this.listeners[eventType] || []).indexOf(listener);
        if (callbackIndex > -1)
            this.listeners[eventType].splice(callbackIndex, 1);
    };
    TypedEventEmitter.prototype.emit = function (eventType, event) {
        (this.listeners[eventType] || []).forEach(function (listener) { return listener(event); });
        /** Clear the `once` queue */
        if ((this.listenersOnce[eventType] || []).length > 0) {
            (this.listenersOnce[eventType] || []).forEach(function (listener) { return listener(event); });
            this.listenersOnce[eventType] = [];
        }
    };
    TypedEventEmitter.prototype.clearAll = function () {
        this.listeners = {};
        this.listenersOnce = {};
    };
    return TypedEventEmitter;
}());
var eventEmitter = new TypedEventEmitter();
exports.default = eventEmitter;
